import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

// import { Heading } from '../../Common/Heading';
// import { CloseIcon } from '../../Icon';
// import { Breakdown } from '../Breakdown';

// const StyledWrapper = styled.div``;

const H4 = styled.h4`
  font-size: calc(var(--bs-h4) - 1px);
  font-weight: var(--weight-bold);
  margin-bottom: 20px;
`;

// const StyledCloseIconWrapper = styled.span`
//   width: 30px;
//   height: 30px;
//   top: -2rem;
//   left: -2rem;
//   padding: 4px;
//   position: relative;
//   z-index: 99;
//   background: #327388;
//   display: inline-block;
//   border-radius: 50%;
//   cursor: pointer;
// `;

// const StyledSummaryWrapper = styled.div`
//   @media (max-width: 767px) {
//     max-height: 300px;
//     overflow-y: scroll;
//   }
// `;

type Props = {
  // modalIsOpen: boolean;
  // openModal: () => void;
  // closeModal: () => void;
  productType: string;
};

export const ProductSummaryModel = ({
  // modalIsOpen,
  // openModal,
  // closeModal,
  productType,
}: Props) => {

  // const customStyles = {
  //   overlay: {
  //     zIndex: 1063,
  //     backgroundColor: 'rgb(36,35,37, 0.25)',
  //   },
  //   content: {
  //     top: '50%',
  //     left: '50%',
  //     right: 'auto',
  //     bottom: 'auto',
  //     width: 'calc(100% - 4rem)',
  //     transform: 'translate(-50%, -50%)',
  //     border: '3px solid #327388',
  //     borderRadius: '10px',
  //     padding: '10px',
  //     overflow: 'visible',
  //   },
  // };

  Modal.setAppElement('#root');

  return (
    <>
      {/* <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <StyledWrapper>
          <StyledCloseIconWrapper onClick={closeModal}>
            <CloseIcon />
          </StyledCloseIconWrapper>
          <StyledSummaryWrapper>
            <Heading>Product Summary - {productType}</Heading>
            <Breakdown />
          </StyledSummaryWrapper>
        </StyledWrapper>
      </Modal> */}
      <H4>{productType}</H4>
    </>
  );
};
